import axios from 'axios';
import {PublicEventType} from 'enums/public_event_type';
import {IPublicEvent} from 'types/publicEvent';

interface IBookEventProps {
  eventId: string;
  memberId: string;
}

export const bookSeminar = async (props: IBookEventProps, onSuccess: (event: IPublicEvent) => void) => {
  const response = await axios.post('/public-events/book', {
    ...props,
    action: 'book',
    eventType: PublicEventType.SEMINAR,
  });

  const {event} = response.data;
  onSuccess(event as IPublicEvent);
};
